<script setup>
import { useBundleStore } from '../pinia/BundleStore'
import { useCartStore } from '../pinia/CartStore'

const BundleStore = useBundleStore()
const CartStore = useCartStore()

CartStore.getCart()
BundleStore.setupBundle()
</script>
